import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
//--------------------------------------------------------------------------------------------
import CSV from "src/components/common/csv"; // UTF-8
import Modal from "src/components/common/modal";
import Resize from "src/components/common/resize";
import magnifierImg from "src/img/magnifier.png";
//import UserInfo from "src/components/main/userInfo";
import { useMyStore } from "src/components/main/mainStore";
import { 
    weeknum, myAxios, MyFormData, MyDate, 
    objectReducer, numberReducer, onlyUnique,
    getDatefromWeekNum0, BillingUploaderEmailList,
    getDateEndFromWeekNum, getDatefromWeekNum,
    boolAndReducer, billingEmails, getTimeStamp,
    appTitle
} from "src/components/common/functions";
import Export from "./export";
const thousandSeparator = number => {
    // Time: O(n) => 
    // Space: O(n) => 
    if(typeof(number) !== "string") return number;
    const res = [];
    let cont = false, start = 0;
    if(!number.includes(".")/* time(n) */){
        cont = true;
        start = number.length;
    }
    for(let i = number.length - 1; i >= 0; i--){ /* time(n) */
        res.push(number[i]); /* space(n) */
        if(i && (i - start) % 3 === 0 && cont) res.push(","); /* space(n / 3) */
        if(number[i] === "."){
            start = i;
            cont = true;
        }
    }
    return res.reverse().join(""); /* time(n) */
}
//--------------------------------------------------------------------------------------------
export default function LaborCost({tabTitle}){
    const setShowLoader = useMyStore(state => state.setShowLoader);
    const user = useMyStore(state => state.user);
    const isPM = (user.projects === "yes") && (user.department !== "Executive");
    //--------------------------------------------------------------------------------------------
    const [showLoading, setShowLoading] = useState(true);
    const [showDetail, setShowDetail] = useState(false);
    const [fileExist, setFileExist] = useState(false);
    const [curWeekStart, setWeekStart] = useState(weeknum(new MyDate()));
    const [curWeekEnd, setWeekEnd] = useState(weeknum(new MyDate()));
    const [importWeek, setImportWeek] = useState(weeknum(new MyDate()));
    const [projectManager, setProjectManager] = useState(isPM?user.userName: "All");
    const [pipeline, setPipeline] = useState("All");
    const [subPipeline, setSubPipeline] = useState("All");
    const [filterWords, setFilterWords] = useState("");
    const [invalid, setInvalid] = useState([]);
    const [projects, setProjects] = useState([]);
    const projectsMap = Object.fromEntries(projects.map(item => [item.projectHashKey,item]))
  
    const [rawData, setRawData] = useState({});
    const realProjects = Object.keys(
        Object.entries(rawData)
        .filter(entry => entry[0] >= curWeekStart && entry[0] <= curWeekEnd)
        .map(entry => entry[1]).reduce(objectReducer, {})
    );
    const filteredProjects = realProjects.filter(projectHashKey => 
        (pipeline === "All"?true:projectsMap[projectHashKey].pipeline === pipeline) && 
        (subPipeline === "All"?true:projectsMap[projectHashKey].subPipeline === subPipeline)
        && (projectManager === "All" || billingEmails.includes(user.email)?true:projectsMap[projectHashKey].projectManager === projectManager)
        && (filterWords.toLowerCase().split(" ").map(f => JSON.stringify(
            projectsMap[projectHashKey]
        ).toLowerCase().indexOf(f) > -1).reduce(boolAndReducer, true))
    );
    const [weeks] = useState(
        () => {
            const dateIterator = new MyDate("2023/1/2");
            const dateArray = [];
            while(dateIterator < getDatefromWeekNum0(weeknum(new MyDate()), 0)){
                dateArray.push(weeknum(dateIterator));
                dateIterator.setDate(dateIterator.getDate() + 7);
            }
            if(!dateArray.includes(weeknum(new MyDate()))){
                dateArray.push(weeknum(new MyDate()));
            }
            return dateArray;
        }
    )
    const [updateDateTime, setUpdateDateTime] = useState(getTimeStamp());
    //---------------------------------------------------------------------
    useEffect(() => {
        let isMounted = true;
        const getData = async () => {
            const formData = new MyFormData();
            // ------------------------------------
            setShowLoading(true);
            const resProjects = await myAxios("importedBillings/readProjects.php", formData);
            if(!isMounted) return;
            setShowLoading(false);
            if(!resProjects) return;
            // ------------------------------------
            setProjects(resProjects.data);
        }
        getData();
        return () => isMounted = false
    }, [updateDateTime])
    useEffect(() => {
        let isMounted = true;
        const getData = async () => {
            // Initialize formData ----------------
            const formData = new MyFormData();
            // Get Data ---------------------------
            formData.append("startWeek", curWeekStart);
            formData.append("endWeek", curWeekEnd);
            // ------------------------------------
            setShowLoading(true);
            const res = await myAxios("importedBillings/readBillings.php", formData);
            if(!isMounted) return;
            setShowLoading(false);
            if(!res) return;
            // ------------------------------------
            setRawData(res.data);
        }
        getData();
        return () => isMounted = false
    }, [curWeekStart, curWeekEnd, updateDateTime])
    useEffect(() => {
        let isMounted = true;
        const getData = async () => {
            const formData = new MyFormData();
            formData.append("importWeek", importWeek);
            // ------------------------------------
            setShowLoader(true);
            const res = await myAxios("importedBillings/importWeek.php", formData);
            if(!isMounted) return;
            setShowLoader(false);
            if(!res) return;
            // ------------------------------------
            setFileExist(res.data === "yes");
        }
        getData();
        return () => isMounted = false
    }, [importWeek])
    useEffect(() => {
        document.title = tabTitle;
        return () => {
            document.title = appTitle;
        };
    }, [tabTitle]);
    //---------------------------------------------------------------------
    return (
        <div className = "cssTab">
            <div className = "cssHeader" style = {{background: user.userTheme}}>
                <span>
                    <Resize/>
                    {tabTitle}
                    <span data-toggle = "tooltip" title = {"Refreshed on " + updateDateTime} className = "btn btn-primary py-1 ml-4" onClick = {() => setUpdateDateTime(getTimeStamp())}>↻</span>
                </span>
                <span>
                    <input
                        className = "form-control w-auto"
                        type = "text"
                        onChange = {e => {
                            setFilterWords(e.currentTarget.value.toLowerCase());
                        }}
                    />
                    <img
                        alt = ""
                        src = {magnifierImg}
                    />
                </span>
                <span className = "d-flex align-items-center">
                    <label htmlFor = "showDetail" className = "mb-0">Show Detail:</label>
                    <input
                        id = "showDetail"
                        type = "checkbox"
                        className = "cssCheckBox ml-2"
                        checked = {showDetail}
                        onChange = {e => {
                            setShowDetail(e.currentTarget.checked);
                        }}
                    />
                </span>
                {isPM?<></>:
                <span className = "d-flex align-items-center">
                    <label htmlFor = "projectManger" className = "mb-0">Project Manager:</label>
                    <select
                        id = "projectManger"
                        className = "form-control w-auto ml-3"
                        value = {projectManager}
                        onChange = {e => {
                            setProjectManager(e.currentTarget.value);
                        }}
                    >
                        <option>All</option>
                        {realProjects.map(projectHashKey => projectsMap[projectHashKey].projectManager).filter(onlyUnique)
                        .map((d, key) => <option key = {key}>{d}</option>)}
                    </select>
                </span>
                }
                <span className = "d-flex align-items-center">
                    <label htmlFor = "pipeline" className = "mb-0">Pipeline:</label>
                    <select
                        id = "pipeline"
                        className = "form-control w-auto ml-2"
                        value = {pipeline}
                        onChange = {e => {
                            setPipeline(e.currentTarget.value);
                        }}
                    >
                        <option>All</option>
                        {realProjects.filter(projectHashKey => isPM?projectsMap[projectHashKey].projectManager === user.userName:true).map(projectHashKey => projectsMap[projectHashKey].pipeline).filter(onlyUnique).map((d, key) => <option key = {key}>{d}</option>)}
                    </select>
                </span>
                <span className = "d-flex align-items-center">
                    <label htmlFor = "subPipeline" className = "mb-0">Sub Pipeline:</label>
                    <select
                        id = "subPipeline"
                        className = "form-control w-auto ml-2"
                        value = {subPipeline}
                        onChange = {e => {
                            setSubPipeline(e.currentTarget.value);
                        }}
                    >
                        <option>All</option>
                        {realProjects.filter(projectHashKey => isPM?projectsMap[projectHashKey].projectManager === user.userName:true).map(projectHashKey => projectsMap[projectHashKey].subPipeline).filter(onlyUnique).map((d, key) => <option key = {key}>{d}</option>)}
                    </select>
                </span>
                <span className = "d-flex align-items-center">
                    <label htmlFor = "start" className = "mb-0">Week Start:</label>
                    <select
                        id = "start"
                        className = "form-control w-auto ml-2"
                        value = {curWeekStart} 
                        onChange = {e => {
                            setWeekStart(e.currentTarget.value);
                        }}
                    >
                        {weeks.filter(wk => wk <= curWeekEnd).map((wk, key) => <option key = {key} value = {wk}>{getDateEndFromWeekNum(wk)}</option>)}
                    </select>
                </span>
                <span className = "d-flex align-items-center">
                    <label htmlFor = "end" className = "mb-0">Week End:</label>
                    <select
                        id = "end"
                        className = "form-control w-auto ml-2"
                        value = {curWeekEnd}
                        onChange = {e => {
                            setWeekEnd(e.currentTarget.value);
                        }}
                    >
                        {weeks.filter(wk => wk >= curWeekStart).map((wk, key) => <option key = {key} value = {wk}>{getDateEndFromWeekNum(wk)}</option>)}
                    </select>
                </span>
                <Export
                    filteredProjects = {filteredProjects}
                    weeks = {weeks}
                    curWeekStart = {curWeekStart}
                    curWeekEnd = {curWeekEnd}
                    projectsMap = {projectsMap}
                />
                {BillingUploaderEmailList.includes(user.email)?
                <>
                {invalid.length?
                <Modal title = {"Invalid"} touchOutsideClose closeIt = {() => {setInvalid([])}}>
                    {invalid.map((invalidItem, invalidindex) => <div key = {invalidindex} className = "user-select-text m-2">{invalidItem}</div>)}
                </Modal>:<></>}
                <span className = "d-flex align-items-center">
                    <label
                        className = "mb-0"
                        onClick = {e => {
                            if((importWeek in rawData) && !window.confirm("Are you sure to overwrite the existing data of the week?")) return;
                            e.currentTarget.nextElementSibling.click();
                        }}
                    >
                        Week to Import:
                    </label>
                    <select
                        className = "form-control w-auto ml-2"
                        value = {importWeek}
                        onChange = {e => {
                            setImportWeek(e.currentTarget.value);
                        }}
                    >
                        {weeks.map((wk, key) => <option key = {key} value = {wk}>{getDateEndFromWeekNum(wk)}</option>)}
                    </select>
                </span>
                <span
                    className = "pointer"
                    onClick = {e => {
                        if((importWeek in rawData) && !window.confirm("Are you sure to overwrite the existing data of the week?")) return;
                        e.currentTarget.nextElementSibling.click();
                    }}
                >
                    Import
                </span>
                <input
                    className = "nodisplay"
                    type = "file"
                    accept = ".csv"
                    onChange = {ev => {
                        const target = ev.currentTarget;
                        if(target.files.length === 1){
                            let reader = new FileReader();
                            reader.onload = async () => {
                                const data = reader.result;
                                const out = CSV.parse(data);
                                if(!out){
                                    window.alert("The file is not supported.");
                                    return;
                                }
                                const valid = out.slice(2, -1).map(row => row.slice(2));
                                const map = {};
                                const curInvalid = [];
                                for(let rowIndex = 0; rowIndex < valid.length; rowIndex++){
                                    const row = valid[rowIndex];
                                    const key = row[2];
                                    if(key){
                                        const filteredKey = key.split(":")[1].split("_")[0];
                                        if(!projects.map(project => project.projectNumber).includes(filteredKey)){
                                            if(
                                                !["PGE", "PG&E"].includes(filteredKey) && 
                                                !["(PG&E_Gas Stand By)", "(PGE_USA Mark & Locate)", "(PGE_GPOM)", "(PGE_QEW Inspectors)"].includes(key)
                                            ){
                                                curInvalid.push(filteredKey);
                                            }
                                        }else{
                                            if(row[3] === 0 || weeknum(row[0]) !== importWeek) continue;
                                            const projectHashKey = projects.find(project => filteredKey === project.projectNumber)?.projectHashKey;
                                            if(!(projectHashKey in map)){
                                                map[projectHashKey] = [];
                                            }
                                            map[projectHashKey].push({date: row[0], billingNumber: row[1], amount: row[3]});
                                        }
                                    }
                                }
                                setInvalid(curInvalid);
                                //if(curInvalid.length > 0) return;
                                const formData = new MyFormData();
                                formData.append("week", importWeek);
                                formData.append("data", JSON.stringify(map));
                                // ------------------------------------
                                setShowLoader(true);
                                const res = await myAxios("importedBillings/createBilling.php", formData);
                                setShowLoader(false);
                                if(!res) return;
                                // ------------------------------------
                                setRawData(rawData => ({...rawData, [importWeek]: map}));
                            }
                            reader.readAsBinaryString(target.files[0]); 
                            //reader.readAsText(target.files[0]); //only works for UTF-8 
                        }
                        target.value = "";
                    }}
                />
                {fileExist?
                <span
                    className = "pointer"
                    onClick = {async() => {
                        if(!window.confirm("Are you sure to delete the existing data of the week?")) return;
                        // ***
                        const formData = new MyFormData();
                        formData.append("week", importWeek);
                        // ------------------------------------
                        setShowLoader(true);
                        const res = await myAxios("importedBillings/deleteBilling.php", formData);
                        setShowLoader(false);
                        if(!res) return;
                        // ------------------------------------
                        delete rawData[importWeek];
                        setRawData(rawData => ({...rawData}));
                    }}
                >
                    Delete
                </span>
                :<></>}
                </>
                :<></>}
            </div>
            {showLoading?<div className = "cssContent pb10"><div className = "cssLoading">Loading...</div></div>:
            !filteredProjects.length?<div className = "cssContent pb10"><div className = "cssLoading">Empty</div></div>:
            <>
            {!isPM?
            <div className = "table-responsive px-2">
                <table className = "table">
                <caption className = "text-center font-weight-bold caption-top">Status Summary ({getDatefromWeekNum(curWeekStart, 0)} ~ {getDatefromWeekNum(curWeekEnd, 6)})</caption>
                    <tbody>
                        <tr>
                            <th>Project Manager</th>
                            {filteredProjects.map(projectHashKey => projectsMap[projectHashKey].projectManager).filter(onlyUnique)
                            .map((pm, pmIndex) => 
                                <th key = {pmIndex}>{pm}</th>
                            )}
                            <th>Total</th>
                        </tr>
                        <tr>
                            <th>Number of Projects</th>
                            {filteredProjects.map(projectHashKey => projectsMap[projectHashKey].projectManager).filter(onlyUnique)
                            .map((pm, pmIndex) => 
                                <th key = {pmIndex}>
                                    {thousandSeparator(realProjects.filter(projectHashKey => 
                                        projectsMap[projectHashKey].projectManager === pm
                                    ).length.toString())}
                                </th>
                            )}
                            <th>
                                {thousandSeparator(filteredProjects.map(projectHashKey => projectsMap[projectHashKey].projectManager).filter(onlyUnique).map(pm => 
                                realProjects.filter(projectHashKey => 
                                    projectsMap[projectHashKey].projectManager === pm
                                ).length
                                ).reduce(numberReducer, 0))}
                            </th>
                        </tr>
                        <tr>
                            <th>Total Billing</th>
                                {filteredProjects.map(projectHashKey => projectsMap[projectHashKey].projectManager).filter(onlyUnique)
                                .map((pm, pmIndex) => 
                                    <th key = {pmIndex} className = "text-success">
                                        {thousandSeparator(filteredProjects.filter(projectHashKey => 
                                            projectsMap[projectHashKey].projectManager === pm
                                        ).map(projectHashKey =>
                                        weeks.filter(week => 
                                            week >= curWeekStart && week <= curWeekEnd
                                        ).map(week => 
                                        rawData[week]?.[projectHashKey]?.map(item => item.amount).reduce(numberReducer, 0) || 0
                                        ).reduce(numberReducer, 0))
                                        .reduce(numberReducer, 0).toFixed(2))}
                                    </th>
                                )}
                            <th className = "text-success">
                                {thousandSeparator(filteredProjects.map(projectHashKey => projectsMap[projectHashKey].projectManager).filter(onlyUnique).map(pm => 
                                filteredProjects.filter(projectHashKey => 
                                    projectsMap[projectHashKey].projectManager === pm
                                ).map(projectHashKey =>
                                weeks.filter(week => 
                                    week >= curWeekStart && week <= curWeekEnd
                                ).map(week => 
                                rawData[week]?.[projectHashKey]?.map(item => item.amount).reduce(numberReducer, 0) || 0
                                ).reduce(numberReducer, 0))
                                .reduce(numberReducer, 0)
                                ).reduce(numberReducer, 0).toFixed(2))}
                            </th>
                        </tr>
                    </tbody>
                </table>
            </div>
            :<></>}
            <div className = "overflow-visible">
                <table className = "table">
                    <thead>
                        <tr className = "stickyHeader">
                            <th>Project Name</th>
                            {weeks.filter(week => week >= curWeekStart && week <= curWeekEnd).map((week, weekIndex) => 
                            <th key = {weekIndex}>{getDateEndFromWeekNum(week)}</th>
                            )}
                            <th>Total Billing</th>
                        </tr>
                    </thead>
                    <tbody className = "noTableTopBorder"> 
                        {filteredProjects
                        .map((projectHashKey, projectIndex) => 
                        <tr key = {projectIndex}> 
                            <th>
                                <Link to = {`/Projects/${projectHashKey}`}>
                                    {projectsMap[projectHashKey].projectName}
                                </Link>
                            </th>
                            {weeks.filter(week => 
                                week >= curWeekStart && week <= curWeekEnd
                            ).map((week, weekIndex) => 
                            <th key = {weekIndex} className = "text-center">
                                {rawData[week] && rawData[week]?.[projectHashKey]?.map(item => item.amount).reduce(numberReducer, 0)?
                                <>
                                {thousandSeparator(rawData[week]?.[projectHashKey]?.map(item => item.amount).reduce(numberReducer, 0).toFixed(2))}
                                {showDetail?
                                <ul>
                                    {thousandSeparator(rawData[week]?.[projectHashKey]?.map(item => 
                                    <li>
                                        <span className = "text-secondary">{item.date}</span>
                                        <span className = "text-info">#{item.billingNumber}</span>
                                        <span className= "text-success">${item.amount}</span>
                                    </li>))}
                                </ul>
                                :<></>}
                                </>
                                :
                                <></>
                                }
                            </th>
                            )}
                            <th className = "text-success text-center">
                                {thousandSeparator(weeks.filter(week => 
                                    week >= curWeekStart && week <= curWeekEnd
                                ).map(week => 
                                rawData[week]?.[projectHashKey]?.map(item => item.amount).reduce(numberReducer, 0) || 0
                                ).reduce(numberReducer, 0).toFixed(2))}
                            </th>
                        </tr>
                        )}
                        <tr> 
                            <th>
                                Total: {filteredProjects.length}
                            </th>
                            {weeks.filter(week => week >= curWeekStart && week <= curWeekEnd).map((week, weekIndex) => 
                            <th key = {weekIndex} className = "text-center">
                                {((num) => num === "0.00"?"":num)(thousandSeparator(filteredProjects.map(projectHashKey => 
                                    rawData[week]?.[projectHashKey]?.map(item => item.amount).reduce(numberReducer, 0) || 0
                                ).reduce(numberReducer, 0).toFixed(2)))}
                            </th>
                            )}
                            <th className = "text-success text-center">
                                {thousandSeparator(filteredProjects.map(projectHashKey =>
                                weeks.filter(week => 
                                    week >= curWeekStart && week <= curWeekEnd
                                ).map(week => 
                                rawData[week]?.[projectHashKey]?.map(item => item.amount).reduce(numberReducer, 0) || 0
                                ).reduce(numberReducer, 0))
                                .reduce(numberReducer, 0).toFixed(2))}
                            </th>
                        </tr>
                    </tbody>
                </table>
            </div>
            </>}
        </div>
    )
}